<template>
    <div class="row small_text" v-if="productCount || productPrice">
        <div class="col-4"><span class="text_overflow">{{ product.name }}</span></div>
        <div class="col-4">
            <span v-if="productCount">{{ format(productCount) }}</span>
            <span v-else>-</span>
        </div>
        <div class="col-4">
            <span v-if="productPrice">{{ format(productPrice) }} Kč</span>
            <span v-else>-</span>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        product: {}
    },
    data() {
        return {
        }
    },
    computed: {
        productCount: function () {
            var product_id = this.product.product_id;
            return this.$evaluate.eval(`ref("${product_id}.count")`);
        },
        productPrice: function () {
            var product_id = this.product.product_id;
            return this.$evaluate.eval(`ref("${product_id}.totalPrice")`);
        }
    },
    methods: {
        format: function (value) {
            return new Intl.NumberFormat().format(value);
        }
    }
}
</script>
<style lang="scss">
</style>